import { PageContainer } from "@/components/layout/PageContainer";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { ArrowRight, Smartphone, Monitor, Workflow } from "lucide-react";

const PlatformDevices = () => {
  return (
    <PageContainer>
      <Helmet>
        <title>AI Platform & Devices - Scienza Health</title>
        <meta name="description" content="Advanced AI-enabled devices and platform integrations for modern healthcare delivery." />
      </Helmet>
      
      <div className="min-h-screen py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
              AI Platform & Devices
            </h1>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Cutting-edge AI-enabled devices and seamless platform integrations that revolutionize healthcare delivery at every touchpoint.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-card border rounded-lg p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-4">
                <Monitor className="h-8 w-8 text-primary mr-3" />
                <h2 className="text-xl font-semibold">AI-Enabled Bedside Devices</h2>
              </div>
              <p className="text-muted-foreground mb-6">
                Advanced bedside monitoring and interaction devices powered by artificial intelligence for enhanced patient care.
              </p>
              <Link 
                to="/platform-devices/ai-enabled-bedside-devices" 
                className="inline-flex items-center text-primary hover:text-primary/80 transition-colors"
              >
                Learn More <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </div>

            <div className="bg-card border rounded-lg p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-4">
                <Smartphone className="h-8 w-8 text-primary mr-3" />
                <h2 className="text-xl font-semibold">Wearables</h2>
              </div>
              <p className="text-muted-foreground mb-6">
                Smart wearable devices that provide continuous health monitoring and seamless data integration with our AI platform.
              </p>
              <Link 
                to="/platform-devices/wearables" 
                className="inline-flex items-center text-primary hover:text-primary/80 transition-colors"
              >
                Learn More <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </div>

            <div className="bg-card border rounded-lg p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-4">
                <Workflow className="h-8 w-8 text-primary mr-3" />
                <h2 className="text-xl font-semibold">EHR Workflow Integrations</h2>
              </div>
              <p className="text-muted-foreground mb-6">
                Seamless integration with existing EHR systems to streamline workflows and enhance data accessibility.
              </p>
              <Link 
                to="/platform-devices/ehr-workflow-integrations" 
                className="inline-flex items-center text-primary hover:text-primary/80 transition-colors"
              >
                Learn More <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default PlatformDevices;